import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { Link } from 'react-router-dom';
const ForgotPassword = () => {
    document.title = "Forgot password";

    const [state, setState] = useState({})

    const handleChange = ({ target: { name, value } }) => {
        setState({
            ...state,
            [name]: value,
        })
    }

    const handleFormSubmit = (event) => {
        console.log(state)
    }

    let { email } = state

    return (
        <div className="container row">
            <div className="col-md-4 px-4 d-flex">
                <img
                    className="w-200"
                    src="https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/shopkpr-personal/logo/logo_1.svg"
                    alt=""
                />
            </div>
            <div className="col-md-6">
                <ValidatorForm onSubmit={handleFormSubmit}>
                    <TextValidator
                        className="w-100 mb-3"
                        variant="outlined"
                        label="Email"
                        onChange={handleChange}
                        type="email"
                        name="email"
                        size="small"
                        value={email || ''}
                        validators={['required', 'isEmail']}
                        errorMessages={[
                            'this field is required',
                            'email is not valid',
                        ]}
                    />
                    <div className="flex items-center">
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            Reset Password
                        </Button>
                        <span className="mx-2 ml-5">or</span>
                        <Link to="/session/login">
                            <Button className="capitalize text-primary text-decoration-underline">
                                Login
                            </Button>
                        </Link>
                    </div>
                </ValidatorForm>
            </div>
        </div>
    )
}

export default ForgotPassword
